import {useMemo} from "react";
import "./index.scss";

// Statistiche stagione importate da Wyscout in "Importa dati" (salvate nel browser)
function getWyscoutPlayerData(playerData) {
	if (!playerData) return null;
	try {
		const saved = localStorage.getItem("wyscout_player_stats");
		if (!saved) return null;
		const imports = JSON.parse(saved);
		if (playerData.id) {
			const byId = imports.find((p) => p.playerId === playerData.id);
			if (byId) return byId;
		}
		const lastName = (playerData.lastName || "").toLowerCase().trim();
		return imports.find((p) =>
			p.playerName?.toLowerCase().includes(lastName) && lastName.length > 2,
		) || null;
	} catch {
		return null;
	}
}

const fmtV = (v, d = 2) => (v != null && !isNaN(v) ? Number(v).toFixed(d) : "—");

export default function PlayerSeasonStats({playerData}) {
	const wyscoutData = useMemo(() => getWyscoutPlayerData(playerData), [playerData]);

	if (!wyscoutData) return null;

	const t = wyscoutData.totals || {};
	const p90 = wyscoutData.per90 || {};

	const summary = [
		{label: "Partite", value: fmtV(wyscoutData.matchCount, 0)},
		{label: "Minuti", value: fmtV(t.minutes, 0)},
		{label: "Gol", value: fmtV(t.goals, 0)},
		{label: "Assist", value: fmtV(t.assists, 0)},
		{label: "Gialli", value: fmtV(t.yellowCards, 0)},
	];

	const per90Stats = [
		{label: "Gol / 90", value: fmtV(p90.goals)},
		{label: "Assist / 90", value: fmtV(p90.assists)},
		{label: "xG / 90", value: fmtV(p90.xG)},
		{label: "Duelli vinti / 90", value: fmtV(p90.duelsWon, 1)},
		{label: "Intercetti / 90", value: fmtV(p90.interceptions)},
	];

	return (
		<div className="pss-root">
			<div className="pss-header">
				<div className="pss-header__left">
					<span className="pss-header__title">Statistiche stagione (Wyscout)</span>
					<span className="pss-header__season">{wyscoutData.playerName}</span>
				</div>
				<span className="pss-header__source">
					Importato il {new Date(wyscoutData.importedAt).toLocaleDateString("it-IT")}
				</span>
			</div>
			<div className="pss-summary">
				{summary.map((s, i) => (
					<div key={i} className="pss-summary__item">
						<span className="pss-summary__value">{s.value}</span>
						<span className="pss-summary__label">{s.label}</span>
					</div>
				))}
			</div>
			<div className="pss-sections">
				<div className="pss-section">
					<div className="pss-section__title">Per 90 minuti</div>
					<div className="pss-section__grid">
						{per90Stats.map((s, i) => (
							<div key={i} className="pss-tile">
								<span className="pss-tile__value">{s.value}</span>
								<span className="pss-tile__label">{s.label}</span>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
}
